export type ApiStatus = "idle" | "run" | "ok" | "error" | "skip";

export type TierKey = "dual-core" | "tier1" | "tier2" | "tier3" | "tier4" | "tier5" | "local";

export interface ApiState {
  name: string;
  tier: TierKey;
  status: ApiStatus;
  ms?: number;
  payload?: unknown;
}

export interface Scan {
  scanId: string;
  targetId: string;
  targetRaw: string;
  action: "discover" | "validate" | "full";
  startedAt: string;
  state: "running" | "done" | "error";
  apis: ApiState[];
  report?: Report | null;
}

export interface CveEntry {
  id: string;
  cvss?: number | null;
  source?: string;
  description?: string;
}

export interface Report {
  executive_summary?: string;
  risk_score?: number;
  confirmed_findings?: string[];
  single_source_signals?: string[];
  exposed_assets?: string[] | Record<string, unknown>;
  cves?: CveEntry[];
  reputation?: Record<string, unknown>;
  recommended_actions?: string[];
  validation_plan?: string[];
  raw?: string;
}

export const TIER_ORDER: TierKey[] = ["dual-core", "tier1", "tier2", "tier3", "tier4", "tier5", "local"];

export const TIER_LABEL: Record<TierKey, string> = {
  "dual-core": "dual-core · dns recon",
  "tier1": "tier 1 · scanners",
  "tier2": "tier 2 · vulns",
  "tier3": "tier 3 · reputation",
  "tier4": "tier 4 · network",
  "tier5": "tier 5 · web",
  "local": "local · nmap",
};

export const API_CATALOG: ApiState[] = [
  { name: "dns_enum",       tier: "dual-core", status: "idle" },
  { name: "whois_rdap",     tier: "dual-core", status: "idle" },
  { name: "shodan",         tier: "tier1",     status: "idle" },
  { name: "censys",         tier: "tier1",     status: "idle" },
  { name: "leakix",         tier: "tier1",     status: "idle" },
  { name: "netlas",         tier: "tier1",     status: "idle" },
  { name: "crtsh",          tier: "tier1",     status: "idle" },
  { name: "zoomeye",        tier: "tier1",     status: "idle" },
  { name: "hunterhow",      tier: "tier1",     status: "idle" },
  { name: "criminalip",     tier: "tier1",     status: "idle" },
  { name: "binaryedge",     tier: "tier1",     status: "idle" },
  { name: "circl",          tier: "tier2",     status: "idle" },
  { name: "vulners",        tier: "tier2",     status: "idle" },
  { name: "nvd",            tier: "tier2",     status: "idle" },
  { name: "virustotal",     tier: "tier3",     status: "idle" },
  { name: "otx",            tier: "tier3",     status: "idle" },
  { name: "greynoise",      tier: "tier3",     status: "idle" },
  { name: "abuseipdb",      tier: "tier3",     status: "idle" },
  { name: "dnsbl",          tier: "tier3",     status: "idle" },
  { name: "ipinfo",         tier: "tier4",     status: "idle" },
  { name: "bgpview",        tier: "tier4",     status: "idle" },
  { name: "ssl_tls",        tier: "tier4",     status: "idle" },
  { name: "urlscan",        tier: "tier5",     status: "idle" },
  { name: "securitytrails", tier: "tier5",     status: "idle" },
  { name: "builtwith",      tier: "tier5",     status: "idle" },
  { name: "hibp",           tier: "tier5",     status: "idle" },
  { name: "sec_headers",    tier: "tier5",     status: "idle" },
  { name: "nmap",           tier: "local",     status: "idle" },
];
